/**
 * Mobile League Navigation — locked global nav (top, League Home).
 * 6 equal cells filling the width: Home · Standings · Messages · Transactions ·
 * Live · Trading Block. Flat segmented control, line icons, gold active state.
 * Routing + active-state behavior unchanged (currentPage / onNavigate).
 */
import React from 'react';
import { navTheme, navIcons } from '../../../services/mobileNavTheme';
import NavCell from './NavCell';

const LEAGUE_ITEMS = [
  { id: 'home', iconKey: 'leagueHome', label: 'Home' },
  { id: 'standings', iconKey: 'standings', label: 'Standings' },
  { id: 'messages', iconKey: 'messageBoard', label: 'Messages' },
  { id: 'transactions', iconKey: 'transactions', label: 'Transactions' },
  { id: 'live-scoring', iconKey: 'liveScoring', label: 'Live' },
  { id: 'trading-block', iconKey: 'tradingBlock', label: 'Trading Block' },
];

const MobileLeagueNavigation = ({ currentPage, onNavigate }) => {
  return (
    <div style={{
      position: 'sticky',
      top: 0,
      zIndex: 100,
      ...navTheme.topStrip,
      marginBottom: navTheme.clearance, // 4px clearance to the header below
    }}>
      <div style={{ display: 'flex', ...navTheme.segment }}>
        {LEAGUE_ITEMS.map((item, i) => (
          <NavCell
            key={item.id}
            Icon={navIcons[item.iconKey]}
            label={item.label}
            isActive={currentPage === item.id}
            onClick={() => onNavigate(item.id)}
            cell={navTheme.topCell}
            divider={i > 0}
            style={{ flex: 1 }}
          />
        ))}
      </div>
    </div>
  );
};

export default MobileLeagueNavigation;
